import React from "react";

const KIND_MAP = {
  generic: {
    active: "success", achieved: "success", completed: "success", closed: "neutral",
    scheduled: "info", planned: "info", open: "warning", in_progress: "info",
    under_investigation: "warning", reviewed: "info", overdue: "danger",
    cancelled: "neutral", left: "neutral", discharged: "neutral", on_leave: "warning",
    respite: "info", hospitalised: "warning", not_achieved: "danger",
  },
  severity: {
    low: "success", medium: "info", moderate: "warning", high: "warning",
    critical: "danger", urgent: "danger",
  },
  kind: {
    complaint: "warning", compliment: "success",
  },
  vitals: {
    normal: "success", watch: "warning", critical: "danger",
  },
};

function computeExpiryTone(dateStr) {
  if (!dateStr) return "neutral";
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return "neutral";
  const diff = Math.floor((d - today) / (1000 * 60 * 60 * 24));
  if (diff < 0) return "danger";
  if (diff <= 30) return "warning";
  return "success";
}

export default function StatusPill({ value, kind = "generic" }) {
  if (value == null || value === "") return <span className="text-slate-300">—</span>;

  let tone = "neutral";
  let label = String(value);

  if (kind === "expiry") {
    tone = computeExpiryTone(value);
    label = value;
  } else {
    const map = KIND_MAP[kind] || KIND_MAP.generic;
    tone = map[String(value).toLowerCase()] || "neutral";
    label = String(value).replace(/_/g, " ");
  }
  return <span className={`pill pill-${tone}`} data-testid={`pill-${label.replace(/\s+/g, "-")}`}>{label}</span>;
}
